import { EcommerceAPI } from "../Client";

const replyPath = (offeringId) => `/offering/${encodeURIComponent(offeringId)}/booking-reply`;

export const getOfferingBookingReplyAPI = (offeringId) =>
  EcommerceAPI.get(replyPath(offeringId));

// The controller accepts both POST and PUT for creating or replacing a reply.
export const saveOfferingBookingReplyAPI = ({ offeringId, request }) =>
  EcommerceAPI.post(replyPath(offeringId), request);

export const updateOfferingBookingReplyAPI = ({ offeringId, request }) =>
  EcommerceAPI.put(replyPath(offeringId), request);

export const deleteOfferingBookingReplyAPI = (offeringId) =>
  EcommerceAPI.delete(replyPath(offeringId));
